/* Sobreescribe freeShippingBarProgress (definida en theme.js) para soportar
   DOS objetivos en la barra del carrito: regalo sorpresa y envio gratis.
   Este archivo se carga despues de theme.js, asi que esta funcion gana. */
function formatARSNoCents(value) {
  var rounded = Math.round(value);
  try {
    return '$' + rounded.toLocaleString('es-AR', { maximumFractionDigits: 0 });
  } catch (e) {
    return '$' + rounded;
  }
}

function freeShippingBarProgress(totalprice) {
  if (currencyRate == null || shippingStatus != `true`) return;

  const maxGoal = parseFloat(currencyRate) || 0;
  const giftGoal = parseFloat(typeof giftRate !== 'undefined' ? giftRate : 0) || 0;
  if (maxGoal <= 0) return;

  const currencyConvertRate = Math.round(maxGoal * (Shopify.currency.rate || 1));
  const giftConvertRate = Math.round(giftGoal * (Shopify.currency.rate || 1));
  const total = totalprice / 100;

  const giftReached = giftConvertRate > 0 && total >= giftConvertRate;
  const shippingReached = total >= currencyConvertRate;

  let shippingText = '';
  const giftMsg = typeof giftmessage !== 'undefined' ? giftmessage : '';
  if (giftConvertRate > 0 && !giftReached && giftMsg) {
    const remainingGift = formatARSNoCents(giftConvertRate - total);
    shippingText = giftMsg.replace('||price||', remainingGift);
  } else if (!shippingReached) {
    const remainingShipping = formatARSNoCents(currencyConvertRate - total);
    shippingText = shippingmessage.replace('||price||', remainingShipping);
  } else {
    shippingText = shippingsuccessmessage;
  }

  let shippingRatePercentage = (total * 100) / currencyConvertRate;
  if (shippingRatePercentage > 100) shippingRatePercentage = 100;
  if (shippingRatePercentage < 0) shippingRatePercentage = 0;

  let giftMarkerPercentage = giftConvertRate > 0 ? (giftConvertRate * 100) / currencyConvertRate : 0;
  if (giftMarkerPercentage > 100) giftMarkerPercentage = 100;
  if (giftMarkerPercentage < 0) giftMarkerPercentage = 0;

  const bars = document.querySelectorAll("[data-main-shipping-bar]");
  if (bars.length > 0) {
    bars.forEach((shippingSelector) => {
      const message = shippingSelector.querySelector(".free-shipping-bar-message");
      const progress = shippingSelector.querySelector(".progress");
      const giftMarker = shippingSelector.querySelector('[data-bar-goal="gift"]');
      const shippingMarker = shippingSelector.querySelector('[data-bar-goal="shipping"]');
      const goalsRow = shippingSelector.querySelector('.free-shipping-bar-goals');

      if (message && progress) {
        shippingSelector.classList.remove("hidden");
        message.textContent = shippingText;
        progress.style.setProperty('--progress', `${shippingRatePercentage}%`);
      }

      if (giftMarker && giftConvertRate > 0) {
        giftMarker.style.setProperty('--goal-position', `${giftMarkerPercentage}%`);
        giftMarker.classList.toggle('is-reached', giftReached);
        giftMarker.classList.remove('hidden');
      } else if (giftMarker) {
        giftMarker.classList.add('hidden');
      }
      if (shippingMarker) {
        shippingMarker.classList.toggle('is-reached', shippingReached);
      }
      if (goalsRow) {
        goalsRow.style.setProperty('--gift-label-position', `${giftMarkerPercentage}%`);
      }
    });
  }
}

/* ===== Formato de precio argentino para el JS del tema =====
   VariantsSetOption.formatMoney (definida en theme.js) es la que arma el
   precio en la PDP al cargar la pagina y al cambiar de variante (color,
   talle, etc). Por defecto usa Shopify.formatMoney y muestra "ARS 101.089,00".
   La reemplazamos aca para que use el mismo formato que el resto del sitio:
   "$" + puntos de miles + coma con centavos SOLO si no son ,00. */
function formatARSPrice(cents) {
  cents = Math.round(cents);
  var whole = Math.floor(cents / 100);
  var decimals = cents % 100;
  var wholeStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  if (decimals > 0) {
    var decStr = decimals < 10 ? '0' + decimals : '' + decimals;
    return '$' + wholeStr + ',' + decStr;
  }
  return '$' + wholeStr;
}

if (typeof VariantsSetOption !== 'undefined') {
  VariantsSetOption.prototype.formatMoney = function (cents) {
    return formatARSPrice(cents);
  };
}

/* ===== Vista rapida: barra de regalo/envio + calculadora transferencia/cuotas =====
   El contenido de la vista rapida se inserta por innerHTML (los <script>
   adentro no corren), asi que observamos el drawer y, cada vez que se carga
   un producto, inicializamos la barra con el total actual del carrito y
   calculamos los montos segun la variante seleccionada. Tambien ajustamos
   la separacion entre fotos del slider a 5px. */
(function () {
  var QV_SLIDE_GAP = 5;

  function updateQuickViewCalc(drawer) {
    var calc = drawer.querySelector('[data-qv-calc]');
    if (!calc) return;
    var priceCents = parseInt(calc.getAttribute('data-price'), 10) || 0;
    var idInput = drawer.querySelector('input[name="id"]');
    var jsonEl = drawer.querySelector('script[data-name="main-product-section"]');
    if (idInput && jsonEl) {
      try {
        var variants = JSON.parse(jsonEl.textContent);
        var v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
        if (v && v.price) priceCents = v.price;
      } catch (e) {}
    }
    if (!priceCents) return;
    var transfer = calc.querySelector('[data-qv-transfer]');
    var cuota = calc.querySelector('[data-qv-cuota]');
    if (transfer) transfer.textContent = formatARSPrice(priceCents * 0.75);
    if (cuota) cuota.textContent = formatARSPrice(priceCents / 3);
  }

  function fixQuickViewSliderGap(drawer) {
    var gallery = drawer.querySelector('product-gallery-media');
    var sw = gallery && gallery.productImages;
    if (!sw || !sw.params) return;
    sw.params.spaceBetween = QV_SLIDE_GAP;
    if (sw.originalParams) sw.originalParams.spaceBetween = QV_SLIDE_GAP;
    if (sw.params.breakpoints) {
      Object.keys(sw.params.breakpoints).forEach(function (bp) {
        sw.params.breakpoints[bp].spaceBetween = QV_SLIDE_GAP;
      });
    }
    sw.update();
  }

  function initQuickView(drawer) {
    var bar = drawer.querySelector('[data-main-shipping-bar]');
    if (bar) {
      var total = parseInt(bar.getAttribute('data-cart-price'), 10) || 0;
      if (typeof freeShippingBarProgress === 'function') freeShippingBarProgress(total);
    }
    updateQuickViewCalc(drawer);
    fixQuickViewSliderGap(drawer);
    setTimeout(function () { fixQuickViewSliderGap(drawer); }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('quickView-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.querySelector('[data-qv-calc]')) initQuickView(drawer);
    }).observe(drawer, { childList: true });
    drawer.addEventListener('change', function () { updateQuickViewCalc(drawer); });
  });
})();

/* ===== Fix estrella trabada en 0 al agregar al carrito =====
   Al agregar un producto, el cart-drawer se re-renderiza via section render
   API, pero el theme.js no siempre re-ejecuta freeShippingBarProgress con el
   nuevo total. Resultado: la estrella y la barra quedan en 0% hasta que la
   pagina se recarga entera.

   Fix defensivo: observamos el #cart-drawer con MutationObserver y, cada vez
   que cambia el contenido interior (re-render) o el atributo data-cart-price
   del modal-dialog-form, disparamos freeShippingBarProgress con el nuevo
   total. Usamos requestAnimationFrame para debounce y evitar loops. */
(function () {
  var scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      var form = document.getElementById('cart-drawer-body-content');
      if (!form) return;
      var price = parseInt(form.getAttribute('data-cart-price'), 10);
      if (isNaN(price)) return;
      if (typeof freeShippingBarProgress === 'function') {
        freeShippingBarProgress(price);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    // Corrida inicial (por si al cargar la pagina el theme no lo hizo).
    scheduleUpdate();

    // Cambios en el contenido del drawer (re-render post add-to-cart) o en
    // el data-cart-price / data-cart-count del form interior.
    new MutationObserver(scheduleUpdate).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart-price', 'data-cart-count']
    });
  });
})();
